import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Compass } from "lucide-react";
import { BackLink } from "@/components/BackLink";

/** A wrong address used to render a blank screen with no way out. */
export default function NotFound({ user }) {
  const home = user?.roles?.includes("academy_coach")
    ? "/academy/coach-dashboard"
    : "/";
  return (
    <div className="min-h-screen bg-[#0a0f1a] flex items-center justify-center px-4"
      data-testid="not-found">
      <Card className="max-w-md w-full p-8 bg-slate-900/60 border-2 border-white/5 text-center">
        <Compass className="w-10 h-10 text-yellow-500 mx-auto mb-4" />
        <h1 className="text-2xl font-bold text-white mb-2">That page isn't here</h1>
        <p className="text-sm text-slate-400 mb-6">
          The address <span className="text-slate-300">{window.location.pathname}</span>{" "}
          doesn't match anything in the app. It may have been renamed.
        </p>
        <div className="flex items-center justify-center gap-2">
          <BackLink to={home} label="Back" className="text-slate-300 hover:text-white"
            testId="not-found-back" />
          <Link to={home} data-testid="not-found-home">
            <Button size="sm">Take me home</Button>
          </Link>
        </div>
      </Card>
    </div>
  );
}
